import React from 'react'
import { withNamespaces } from 'react-i18next'
const moment = require('moment')

const DayCard = ({ reading, t }) => {
    let newDate = new Date()
    const weekday = reading.dt * 1000
    newDate.setTime(weekday)

    const imgURL = `owf owf-${reading.weather[0].id} owf-5x`

    return (
        <div className="border-card ml-3 text-left text-center shadow-boxs b-0">
            <h4 className="card-title blue">{moment(newDate).format('dddd')}</h4>
            <p className="text-muted">{moment(newDate).format('DD MMMM')}</p>
            <i className={imgURL}></i>
            <h4 className="blue">{Math.round(reading.main.temp) + "°C"}</h4>
            <div className="card-body">
                <p className="card-text black" style={{fontSize: "12px"}}>{reading.weather[0].description}</p>
                <p className="text-center black" style={{fontSize: "12px"}}>{t('humidity')} : {reading.main.humidity}%</p>
                <p className="text-center black" style={{fontSize: "12px"}}>{t('windSpeed')} : {reading.wind.speed} m/s</p>
                <p className="text-center black" style={{fontSize: "12px"}}>{t('windDegree')} : {reading.wind.deg}°</p>
            </div>
        </div>
    )
}

export default withNamespaces()(DayCard);